import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { ReducerState } from "../../types";
import TrapTable from "../../components/Traps/index";
import DeviceSetup from "../../components/DeviceSetup";
import { selectDevice, setWifiModalOpen } from "../../reducers/devicesSlice";
import { useListDevicesQuery } from "../../actions/devicesInQuery";
import "./index.css";
import { displayErrorNotification } from "../../actions";
import {
  BLUETOOTH_STATES,
  useBluetooth,
} from "../../providers/bluetoothProvider";
import { useAppDispatch } from "../../hooks";
import { Device } from "../../types";

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, { displayErrorNotification });

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const Traps: React.FC<Props> = ({ displayErrorNotification }) => {
  const dispatch = useAppDispatch();

  const { data: devices } = useListDevicesQuery();

  const handleSendErrorMessage = (msg: string) => {
    displayErrorNotification(msg);
  };

  const {
    connect,
    disconnect,
    connected,
    bluetoothState,
    scanWifi,
    startWifiConnect,
    isWifiConnected,
    currentNetwork,
  } = useBluetooth({ handleSendErrorMessage });

  const handleConnect = async (deviceUuid: string) => {
    try {
      const success = await connect();
      if (!success) {
        displayErrorNotification(
          `Failed to connect to ${deviceUuid}. Please refresh the page and try again.`,
        );
      }
      dispatch(setWifiModalOpen(true));
      const device = devices?.items.find((d) => d.uuid === deviceUuid);
      if (device) {
        dispatch(selectDevice(device as Device));
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  return (
    <div className="px-6 h-full w-full">
      <div className="text-[40px] my-6">Traps</div>
      <TrapTable
        handleConnect={handleConnect}
        isConnecting={bluetoothState === BLUETOOTH_STATES.CONNECTING}
      />
      <DeviceSetup
        disconnect={disconnect}
        connected={connected}
        bluetoothState={bluetoothState}
        scanWifi={scanWifi}
        startWifiConnect={startWifiConnect}
        isWifiConnected={isWifiConnected}
        currentNetwork={currentNetwork}
      />
    </div>
  );
};

export default connector(Traps);
